<template>
  <div class="steps-bar">
    <template v-for="step in menu">
      <router-link v-bind:to="step.route" class="steps-bar__step" v-if="step.active"
                   v-bind:class="step.active ? 'active' : ''"
                   v-bind:key="step.route"
      >
        <div class="steps-bar-before">
          <span class="step-count">{{ step.step }}</span>
        </div>
        {{ step.name }}
      </router-link>
      <router-link v-bind:to="step.route" class="steps-bar__step" event="" v-else v-bind:key="step.route">
        <div class="steps-bar-before">
          <span class="step-count">{{ step.step }}</span>
        </div>
        {{ step.name }}
      </router-link>
    </template>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'

  export default {
    name: "Menu",
    data: function () {
      return {
        menu: {
          step1: {
            active: false,
            name: 'Выбор дат',
            step: 1,
            route: '/'
          },
          step2: {
            active: false,
            name: 'Участники',
            step: 2,
            route: '/contacts'
          },
          step3: {
            active: false,
            name: 'Подтверждение',
            step: 3,
            route: '/confirm'
          },
          step4: {
            active: false,
            name: 'Оплата',
            step: 4,
            route: '/pay'
          },
          step5: {
            active: false,
            name: 'Завершение',
            step: 5,
            route: '/success'
          },
        }
      }
    },
    mounted() {
      this.setLinks(this.$router.currentRoute.name)
    },
    watch: {
      $route(to) {
        this.setLinks(to.name);
      }
    },
    methods: {
      deactivateLinks: function () {
        for (let id in this.menu) {
          this.menu[id].active = false;
        }
      },
      setLinks: function (name) {
        switch (name) {
          case 'directions':
          case 'events':
            this.deactivateLinks();
            this.menu.step1.active = true;
            this.setCurrentRouteName(this.menu.step1.name);
            break;
          case 'contacts':
            this.deactivateLinks();
            this.menu.step1.active = true;
            this.menu.step2.active = true;
            this.setCurrentRouteName(this.menu.step2.name);
            break;
          case 'confirm':
            this.deactivateLinks();
            this.menu.step1.active = true;
            this.menu.step2.active = true;
            this.menu.step3.active = true;
            this.setCurrentRouteName(this.menu.step3.name);
            break;
          case 'pay':
            this.deactivateLinks();
            this.menu.step4.active = true;
            this.setCurrentRouteName(this.menu.step4.name);
            break;
          case 'success':
            this.deactivateLinks();
            this.setEventPaid();
            this.menu.step5.active = true;
            this.setCurrentRouteName(this.menu.step5.name);
            break;
        }
      },
      ...mapMutations([
        'setEventPaid',
        'setCurrentRouteName'
      ])
    }
  }
</script>

<style scoped>
  .steps-bar__step.router-link-exact-active {
    opacity: 1;
  }
</style>